export default "__VITE_ASSET__CiPzEss9__"